export const difficultyItems = [
  { label: 'Easy', value: 'easy' },
  { label: 'Medium', value: 'medium' },
  { label: 'Hard', value: 'hard' },
];

export const testCasesWarningMessage =
  'Any modification/deletion of test cases will be published to the question spontaneously. If this question is added to an ongoing test. Please be sure before you make any changes!';
